import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [params] = useSearchParams();
  const next = params.get("next") || "/";
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) { toast.success("Welcome back"); nav(next); }
    else setError(res.error);
  };

  return (
    <div data-testid="login-page" className="pt-32 pb-24 max-w-md mx-auto px-4">
      <h1 className="font-display font-black text-4xl tracking-tighter mb-2">Sign in</h1>
      <p className="text-zinc-400 text-sm mb-8">Get back to your glow.</p>
      <form onSubmit={submit} className="space-y-4">
        <div>
          <label className="text-xs uppercase tracking-widest text-zinc-500">Email</label>
          <input data-testid="login-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="input-dark mt-2" />
        </div>
        <div>
          <label className="text-xs uppercase tracking-widest text-zinc-500">Password</label>
          <input data-testid="login-password-input" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="input-dark mt-2" />
        </div>
        {error && <p data-testid="login-error" className="text-sm text-red-400">{error}</p>}
        <button data-testid="login-submit-btn" disabled={loading} className="btn-primary w-full">{loading ? "Signing in…" : "Sign in"}</button>
      </form>
      <p className="text-sm text-zinc-500 mt-6">New here? <Link to="/register" className="text-[#05D9E8] hover:underline" data-testid="goto-register">Create an account</Link></p>
    </div>
  );
}
